<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>Cadastrar Valor</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3">
            <label for="nome">Título</label>
            <input id="nome" type="text" class="form-control" placeholder="Digite o título do valor:" v-model="state.nome.value" />
            <span v-if="state.nome.error" class="text-danger">Este campo é obrigatório</span>
          </div>
          <div class="col-md-3">
            <label for="valor">Valor</label>
            <input id="valor" type="text" class="form-control" placeholder="Digite um valor:" v-mask-decimal.br="2"
              v-model="state.valor.value" />
            <span v-if="state.valor.error" class="text-danger">Este campo é obrigatório</span>
          </div>

          <div class="col-md-3">
            <label for="tipo">Tipo</label>
            <select v-model="state.tipo.value" class="form-select">
              <option value="PROFISSIONAL">Profissional</option>
              <option value="CLINICA">Clinica</option>
            </select>
            <span v-if="state.tipo.error" class="text-danger">Este campo é obrigatório</span>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarValor" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/valores">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: '',
      nome: {
        value: "",
        error: false,
      },
      valor: {
        value: "",
        error: false,
      },
      tipo: {
        value: "",
        error: false,
      }
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetch();
      }
    });
    async function fetch() {
      try {
        const { data } = await services.valor.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome.value = data.nome;
        state.valor.value = data.valor;
        state.tipo.value = data.tipo_valor;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarValor() {
      var erro_validacao = false;
      if (state.nome.value.length == 0) {
        state.nome.error = true;
        erro_validacao = true;
      }
      if (state.valor.value.length == 0) {
        state.valor.error = true;
        erro_validacao = true;
      }
      if (state.tipo.value.length == 0) {
        state.tipo.error = true;
        erro_validacao = true;
      }
      if (erro_validacao == true) {
        return;
      }
      if (!state.id) {
        console.log(token)
        let dados = {
          nome: state.nome.value,
          valor: state.valor.value,
          tipo_valor: state.tipo.value,
          token,
        };
        await services.valor.save(dados, token)
          .then((data) => {
            console.log(data);
            router.push({ name: "Valores" });
          }).catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        let dados = {
          id: state.id,
          nome: state.nome.value,
          valor: state.valor.value,
          tipo: state.tipo.value,
          token,
        };
        await services.valor
          .update(
            dados, token
          )
          .then((data) => {
            console.log(data);
            router.push({ name: "Valores" });
          })
          .catch((error) => {
            console.log(error);
            //var valores = Object.values(error.response.data.errors);
            // alert(valores);
          });
      }
    }
    return {
      salvarValor,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #47b0a9;
}

select {
  border: solid 1px #000;
}

select:focus {
  border: solid 1px #47b0a9;
}

.btns_right {
  text-align: right;
  margin-top: 1rem;
}

.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_save:hover {
  background: #008000;
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_cancel:hover {
  background: #8f0303;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

textarea {
  resize: none;
  border: solid 1px #000;
}

textarea:focus {
  border: solid 1px #47b0a9;
}

#pills-home-tab {
  color: #000;
}

#pills-home-tab:focus {
  color: #47b0a9;
}

#pills-profile-tab {
  color: #000000;
}

#pills-profile-tab:focus {
  color: #47b0a9;
}

.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}

tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}

thead {
  color: #000;
  text-align: center;
  background: gray;
}

td {
  color: #000;
  text-align: center;
}

.table {
  margin-top: 2rem;
}

.imagem {
  width: 100%;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
}

.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
</style>